export function searchSideState(type) {
	return `${type}_search`;
}

export function moveSideState(type) {
	return `${type}_move`;
}
